
import {
getRegionList,
addAddress,
updateAddress,
getAddress,
getRegionTownList,
deleteAddress,
getProfile,
initWxJSSDK
} from "../../../common/js/api.js";
import { addDay } from "../../../common/js/utils.js";
const tabs = () => ["省/直辖市", "", "", ""];
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import CheckIcon from 'vux/src/components/check-icon/index.vue'


export default {
directives: {
TransferDom
},
components: {
Tab,
TabItem,
XHeader,
XInput,
XTextarea,
XButton,
Box,
Group,
CellBox,
Cell,
Picker,
PopupPicker,
Popup,
CheckIcon
},
data() {
return {
currentTabIndex: 0,
view: {
openAddressPicker: false,
action: "add"
},
gender_m: "focus",
gender_f: "",
entity: {
name: "",
areaCode: "",
address: "",
zipCode: "",
mobile: "",
appointTimeDefault: [],
isDefaultFlag: false,
gender: "M",
areaCodeText: "",
ButtonState: false
},
choiceList: tabs(),
choiceItems: [],
regions: [],
currentRegions: [],
currentParentCode: "Area_China",
appointTimeDefault: []
};
},
methods: {
initUI() {
let self = this;
},
changeName(v) {
if (!v) {
return;
}
let self = this;
setTimeout(function() {
self.entity.name = self.entity.name.replace(
/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
""
);
self.$forceUpdate();

}, 500);
},
changeAddress(v) {
if (!v) {
return;
}
let self = this;
setTimeout(function() {
self.entity.address = self.entity.address.replace(
/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
""
);
self.$forceUpdate();

}, 500);
},

changeTab(idx) {
let self = this;
if (!this.choiceItems[idx] || !this.choiceItems[idx].parentCode) {
return;
}
self.currentParentCode = this.choiceItems[idx].parentCode;
if (idx < 3) {
self.initCurrentRegions();
} else {
getRegionTownList({ data: { parentId: self.currentParentCode } }).then(
function(data) {
self.currentRegions = data.Content;
}
);
}
},
changeGender(v) {
let self = this;
if (v === "M") {
self.entity.gender = "M";
} else {
self.entity.gender = "F";
}
},
getChoiceAddress() {
let self = this;
self.entity.areaCode = self.choiceItems[this.choiceItems.length - 1].code;
self.entity.areaCodeText = "";
for (var i = 0; i < self.choiceItems.length; i++) {
self.entity.areaCodeText += self.choiceItems[i].name;
}
},
checkThis(item) {
let self = this;

if (item.rank == 2) {
this.choiceItems = [];
this.choiceItems.push(item);
} else if (item.rank == 3) {
if (this.choiceItems.length > 1) {
this.choiceItems.splice(1, this.choiceItems.length - 1);
}
this.choiceItems.push(item);
} else if (item.rank == 4) {
if (this.choiceItems.length > 2) {
this.choiceItems.splice(2, this.choiceItems.length - 2);
}
this.choiceItems.push(item);
self.currentRegions = [];
getRegionTownList({ data: { parentId: item.code } }).then(function(
data
) {
self.currentRegions = data.Content;
});
} else if (item.rank == 5) {
if (this.choiceItems.length > 3) {
this.choiceItems.splice(3, 1);
}
this.choiceItems.push(item);
self.view.openAddressPicker = false;
self.getChoiceAddress();
}
let arr = [];
for (var i = 0; i < this.choiceItems.length; i++) {
arr.push(this.choiceItems[i].name);
}
if (arr.length == 1) {
arr.push("市");
} else if (arr.length == 2) {
arr.push("区/县");
} else if (arr.length == 3) {
arr.push("街道/镇");
}
let len = arr.length;

this.currentTabIndex = len - 1;

for (var i = 0; i < 4 - len; i++) {
arr.push("");
}

this.choiceList = arr;


if (item.rank >= 2 && item.rank < 4) {
self.currentParentCode = item.code;
self.initCurrentRegions();
}
},
initCurrentRegions() {
let self = this;
let arr = [];
for (var i = 0; i < self.regions.length; i++) {
if (self.currentParentCode == self.regions[i].parentCode) {
arr.push(self.regions[i]);
}
}
self.currentRegions = arr;
},
getRegionList() {
let self = this;
getRegionList().then(function(data) {
self.regions = data.Content;
self.currentParentCode = "Area_China";
self.initCurrentRegions();
});
},
addAddress() {
let self = this;
addAddress({ data: this.entity }).then(function(data) {
if (self.$route.query.from == "shop") {
self.$wechat.miniProgram.navigateBack({ delta: 1 });
} else {
self.$router.go(-1);
}
});
},
updateAddress() {
let self = this;
updateAddress({ data: this.entity }).then(function(data) {
if (self.$route.query.from == "shop") {
self.$wechat.miniProgram.navigateBack({ delta: 1 });
} else {
self.$router.go(-1);
}
});
},
deleteAddress() {
let self = this;
deleteAddress({ data: { recordID: this.entity.recordID } }).then(function(
data
) {
if (self.$route.query.from == "shop") {
self.$wechat.miniProgram.navigateBack({ delta: 1 });
} else {
self.$router.go(-1);
}
});
},
getAddress(recordId) {
let self = this;
getAddress({ data: { recordId: recordId } }).then(function(data) {
self.entity = data.Content;


if (self.entity.isDefault == "1") {
self.entity.isDefaultFlag = true;
}
});
},
onDelete() {
let self = this;
self.$vux.confirm.show({

title: "提醒您",
content: "确定删除该地址？",
onCancel() {},
onConfirm() {
self.deleteAddress();
}
});
},
onSubmit() {
if (!this.entity.name) {
this.$vux.toast.text("请输入联系人姓名");
return;
}
if (!this.entity.mobile) {
this.$vux.toast.text("请输入联系电话");
return;
} else {
var pattern = /^1[2|3|4|5|6|7|8|9]\d{9}$/;
if (!pattern.test(this.entity.mobile)) {
this.$vux.toast.text("手机号不正确");
return;
}
}
if (!this.entity.areaCode) {
this.$vux.toast.text("请选择所在地区");
return;
}
if (!this.entity.address) {
this.$vux.toast.text("请输入详细地址");
return;
}
if (this.entity.isDefaultFlag) {
this.entity.isDefault = 1;
} else {
this.entity.isDefault = 0;
}
if (this.view.action == "add") {
this.addAddress();
} else {
this.updateAddress();
}
}
},
created() {

console.log("created");
},
mounted() {

console.log("mounted");


},
activated() {

initWxJSSDK();
let self = this;
self.entity.areaCodeText = ""

self.entity.address = ""
self.entity.isDefaultFlag = false
if (this.$route.query.recordId) {
this.view.action = "update";
this.getAddress(this.$route.query.recordId);
} else {
this.view.action = "add";
getProfile({}).then(function(data) {
self.entity.mobile = data.Content.mobile;
self.entity.name = data.Content.realName;
});
}
this.getRegionList();
console.log("activated");
},
deactivated() {

console.log("deactivated");
}
};



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/AddressEdit.vue